import { BaseAPI, api } from '@services/api';

class API extends BaseAPI {
  constructor() {
    super('/nnc/production-phase');
  }

  getNextOrder = async () => {
    return api.get(this.buildUrl('get_next_order'));
  };
}

export default new API();
